import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import axios from 'axios';
import Paper from '@material-ui/core/Button';
import UserItems from '../components/menu/userItems';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Image from 'material-ui-image';

import { Link } from 'react-router-dom';
//import Checkout from "../components/checkout";
import Card from '@material-ui/core/Card';
class user extends Component {
  state = {
    entreeItems: [],
    sideItems: [],
    drinkItems: [],
    handle: '',
    userData: [],
    imageUrl: '',
    shortDescription: null,
    popularImg: '',
  };

  componentWillReceiveProps(nextProps) {}
  componentDidMount() {
    const handle = this.props.match.params.handle;
    this.setState({
      handle: handle,
    });

    if (handle === 'Chuys') {
      this.setState({
        popularImg: 'birriachuys2.png',
        shortDescription:
          'Soft taco filled with homemade mexican brisket, onion, cilantro.',
      });
    } else {
      this.setState({
        popularImg: 'pngwing.com.png',
        shortDescription:
          'Delicious homemade soul food cuisine made to perfection!',
      });
    }
    axios
      .get('/menu/' + this.props.match.params.handle + '/entrees')
      .then((res) => {
        this.setState({
          entreeItems: res.data,
        });
      })
      .catch((err) => console.error(err));

    axios
      .get('/menu/' + this.props.match.params.handle + '/sides')
      .then((res) => {
        this.setState({
          sideItems: res.data,
        });
      })
      .catch((err) => console.error(err));

    axios
      .get('/menu/' + this.props.match.params.handle + '/drinks')
      .then((res) => {
        this.setState({
          drinkItems: res.data,
        });
      })
      .catch((err) => console.error(err));

    axios
      .get('/user/' + handle)
      .then((res) => {
        this.setState({
          userData: res.data.user,
        });
      })
      .catch((err) => console.error(err));
  }

  render() {
    return (
      <div style={{ maxWidth: 410, margin: '0 auto' }}>
        <div>
          <Paper
            style={{
              padding: '0px 0px',
            }}
          >
            {this.state.userData.imageUrl == null ? (
              <div
                style={{
                  height: '35vh',
                  paddingLeft: '170px',
                  paddingTop: '15vh',
                  width: '100%',
                }}
              >
                loading...
              </div>
            ) : (
              <Image
                alt="s"
                src={this.state.userData.imageUrl}
                style={{
                  width: '100vw',
                }}
              />
            )}
          </Paper>
        </div>
        <Divider />

        <div style={{ backgroundColor: 'white' }}>
          <Paper style={{ height: '19vh', width: '100%' }}>
            <div style={{}}>
              <Typography
                style={{ fontWeight: 'bold', marginLeft: '-52' }}
                variant="body2"
              >
                $ - Mexican, Authentic
              </Typography>
            </div>

            <div style={{}}>
              <Typography
                style={{
                  color: '#5ebb5e',
                  paddingBottom: '20px',
                  fontSize: '0.8rem',
                }}
                variant="body1"
              >
                Open Now
              </Typography>
            </div>
            <div>
              <Paper style={{}}>
                <div style={{}}>
                  <a href="/">
                    <Avatar style={{ backgroundColor: '#eae9e9' }}>
                      <img
                        style={{ height: '3vh' }}
                        src="map2.png"
                        alt="something"
                        href="/"
                      />
                    </Avatar>
                  </a>
                  <Typography
                    style={{ paddingLeft: '5px' }}
                    align="left"
                    variant="body2"
                  >
                    Map
                  </Typography>
                </div>
              </Paper>
              <Paper style={{}}>
                <a
                  style={{ textDecoration: 'none', color: 'black' }}
                  href={'tel:1-' + this.state.userData.phone}
                >
                  <div>
                    <Avatar style={{ backgroundColor: '#eae9e9' }}>
                      <img
                        style={{ height: '3vh' }}
                        src="telephone.png"
                        alt="something"
                      />
                    </Avatar>
                    <Typography
                      style={{ paddingLeft: '6px' }}
                      align="left"
                      variant="body2"
                    >
                      Call
                    </Typography>
                  </div>
                </a>
              </Paper>
              <Paper style={{}}>
                <div>
                  <Avatar style={{ backgroundColor: '#eae9e9' }}>
                    <img
                      style={{ height: '3.5vh' }}
                      src="photoic.png"
                      alt="something"
                    />
                  </Avatar>
                  <Typography align="left" variant="body2">
                    Photos
                  </Typography>
                </div>
              </Paper>
              <Paper style={{}}>
                <div>
                  <Link
                    style={{ textDecoration: 'none', color: '#0095ff' }}
                    to={{
                      pathname: `checkout/${this.state.handle}`,

                      state: {
                        entrees: this.state.entreeItems,
                        sides: this.state.sideItems,
                        drinks: this.state.drinkItems,
                        handle: this.state.handle,
                        imageUrl: this.state.userData.imageUrl,
                      },
                    }}
                  >
                    <Avatar style={{ backgroundColor: '#eae9e9' }}>
                      <img
                        style={{ height: '3vh' }}
                        src="retail.png"
                        alt="something"
                      />
                    </Avatar>
                  </Link>
                  <Typography align="left" variant="body2">
                    Shop
                  </Typography>
                </div>
              </Paper>
            </div>
          </Paper>
        </div>
        <UserItems
          menu={this.state.entreeItems}
          sides={this.state.sideItems}
          drinks={this.state.drinkItems}
        />
        <Card style={{ display: 'flex', maxHeight: '170px' }}>
          <img
            alt="ss"
            src={this.state.popularImg}
            style={{ maxHeight: '160px', maxWidth: '130px', padding: '10px' }}
          />
          <div>
            <Typography
              variant="h6"
              style={{
                backgroundColor: 'white',

                fontWeight: 'bold',
                textAlign: 'center',
              }}
            >
              Popular
            </Typography>
            <div style={{}}>
              <Typography
                variant="body2"
                style={{
                  textAlign: 'right',
                  display: 'contents',
                  fontSize: '0.8rem',
                  color: 'rgb(118, 118, 118)',
                }}
              >
                {this.state.shortDescription}
              </Typography>
            </div>
            <Button
              style={{
                height: '4vh',

                fontWeight: 'bold',
                marginLeft: '2vw',
                borderRadius: '5x',
                marginBottom: '6px',
                // backgroundColor: "rgb(0 0 0 / 12%)",
              }}
            >
              <Link
                style={{ textDecoration: 'none', color: '#0095ff' }}
                to={{
                  pathname: `checkout/${this.state.handle}`,

                  state: {
                    entrees: this.state.entreeItems,
                    sides: this.state.sideItems,
                    drinks: this.state.drinkItems,
                    handle: this.state.handle,
                  },
                }}
              >
                Order Now
                <img
                  alt="sw"
                  style={{
                    height: '3vh',
                    paddingTop: '4px',
                    marginBottom: '-4px',
                    paddingLeft: '8px',
                  }}
                  src="smallup2.png"
                />
              </Link>
            </Button>
          </div>
        </Card>

        <Divider />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  // data:state.data,
  user: state.user,
});
user.propTypes = {
  // data:PropTypes.object.isRequired
  user: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(user);
